import React from 'react'
import { Router } from 'react-router-dom'
import styled from 'styled-components'
import { initTracking } from '../lib/tracking'
import { ErrorBoundary } from 'react-error-boundary'
import DefaultErrorFallback from './DefaultErrorFallback'
import usePreventUnload from '../hooks/usePreventUnload'
import SiteContainer from './SiteContainer'
import { CenteringContainer } from './CenteringContainer'
import InlineLink from './InlineLink'

const history = initTracking()

/**
 * The main App
 */
const App = () => {
  /**
   * Stop users from unloading the window, eg. if something is being uploaded
   */
  usePreventUnload()

  return (
    <ErrorBoundary FallbackComponent={DefaultErrorFallback}>
      <Router history={history}>
        <SiteContainer>
          <CenteringContainer>
            <ViewsContainer>
              <div>
                <h3>Thank you for visiting Pickr.lol</h3>
              </div>
              <div>
                After a fun and meaningful run:
                <ul>
                  <li>20,000+ game completions</li>
                  <li>50,000+ choices made</li>
                  <li>100+ topics created</li>
                </ul>{' '}
                Pickr.lol is officially closing down.
              </div>
              <div>
                What started as a simple idea turned into something special—and
                it was incredible to see so many different and diverse interests
                come together here.
              </div>
              <div>
                Whether you came here once or returned many times, your presence
                meant a lot.
              </div>
              <div>
                The code is now open sourced under the MIT license and available
                in this{' '}
                <InlineLink>
                  <a href="https://github.com/peterj35/pickrlol">
                    pickrlol github repo
                  </a>
                </InlineLink>{' '}
                for anyone who wants to extend or host it.
              </div>

              <Signature>
                <div>Best regards,</div>
                <div>Peter</div>
              </Signature>
            </ViewsContainer>
          </CenteringContainer>
        </SiteContainer>
      </Router>
    </ErrorBoundary>
  )
}

const ViewsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
`

const Signature = styled.div`
  margin-top: 8px;
`

export default App
